// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"27f42deb","50":"4f464bdb","170":"cdac7008","413":"2a384b3e","488":"c1ec5565","703":"3dee7a41","883":"cfc9cefb","885":"5ab4a744","887":"a1fb45e7","981":"55745c9f"}[chunkId] + ".chunk.js";
};